module.exports = __webpack_public_path__ + "assets/img/a4ca15e2ac09f39c5d070d69a1e2e4ab.svg";